import React from 'react';
import SpinnerOverlay from '../../Ui/SpinnerOverlay';

export default function BespokeCopyVersionSelect({
	versions,
	value,
	onChange,
	loading,
}) {
	if (loading) {
		return (
			<div className="form-group m-auto col-md-6">
				<SpinnerOverlay />
			</div>
		);
	}

	if (!versions?.length) {
		return null;
	}

	return (
		<div className="form-group m-auto col-md-6">
			<label htmlFor="sourceTemplateVersion">Template version to copy</label>
			<select
				className="form-control mb-2 border rounded-right"
				id="sourceTemplateVersion"
				value={value}
				onChange={onChange}
			>
				{versions.map((version) => (
					<option key={version.templateVersion} value={version.templateVersion}>
						{version.templateVersion}
						{version.isCurrentVersion ? ' (current)' : ''}
					</option>
				))}
			</select>
		</div>
	);
}
